// extracted by mini-css-extract-plugin
export default {"assetContainer":"PostForPostWithPoll_assetContainer__0gIFg"};